const ACCESS_TOKEN_KEY = "access_token";

// Save token
export const setAccessToken = (token) => {
  localStorage.setItem(ACCESS_TOKEN_KEY, token);
};

// Get token
export const getAccessToken = () => {
  return localStorage.getItem(ACCESS_TOKEN_KEY);
};

// Remove token
export const removeAccessToken = () => {
  localStorage.removeItem(ACCESS_TOKEN_KEY);
};

// Clear all auth data
export const clearAuthData = () => {
  localStorage.removeItem(ACCESS_TOKEN_KEY);
};